import {Injectable} from '@angular/core';
import {AppService} from '../../../core/services/app.service';
import {HttpClient} from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class CommentService {
    commentAPI = AppService.getApiUrl() + '/api/comments';

    constructor(private http: HttpClient) {
    }

    getComments(photoId) {
        const url = `${this.commentAPI}?filter[include]=customer&filter[where][photoId]=${photoId}`;
        return this.http.get(url);
    }

    postComment(comment) {
        return this.http.post(this.commentAPI, comment);
    }
}

